import * as React from "react";
const CheckXMedium = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "currentColor", width: size || "16", height: size || "16", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M11.2931 4.29297L12.7072 5.70708L6.78508 11.6292L3.29297 8.13708L4.70707 6.72297L6.78508 8.80097L11.2931 4.29297Z", clipRule: "evenodd" }));
CheckXMedium.displayName = "CheckXMedium";
var CheckXMedium_default = CheckXMedium;
export {
  CheckXMedium_default as default
};
